<div class="duna-catering-unique-links-container">
  <mat-card class="header-card">
    <mat-card-header>
      <mat-card-title><h1>Forplejningsansvarlige</h1></mat-card-title>
      <mat-card-subtitle>
        Søg bruger, opret stabilt link til <code>/catering/:uuid</code>, og kopiér linket igen senere.
      </mat-card-subtitle>
    </mat-card-header>
  </mat-card>

  <mat-card class="search-card">
    <mat-card-content>
      <div class="search-row">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Søg bruger</mat-label>
          <input
            matInput
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchTermChange($event)"
            (keyup.enter)="searchUsers()"
            placeholder="Navn eller email">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="searchUsers()" [disabled]="searching || searchTerm.trim().length < 2">
          {{ searching ? 'Søger...' : 'Søg' }}
        </button>
      </div>

      @if (errorMessage) {
        <div class="state state-error">{{ errorMessage }}</div>
      }

      @if (searchResults.length) {
        <div class="results-list">
          @for (user of searchResults; track trackByUserId($index, user)) {
            <div class="result-row">
              <div class="result-meta">
                <div class="name">{{ user.name || 'Ukendt bruger' }}</div>
                <div class="email">{{ user.email || 'Ingen email' }}</div>
                @if (educationalPathsLabel(user)) {
                  <div class="paths">{{ educationalPathsLabel(user) }}</div>
                }
              </div>
              <button mat-stroked-button color="primary" (click)="createOrGetLink(user)" [disabled]="creating || !user.user_uuid">
                {{ user.link_uuid ? 'Opdater i liste' : 'Tilføj link' }}
              </button>
            </div>
          }
        </div>
      } @else if (searchTerm.trim().length >= 2 && !searching) {
        <div class="state">Ingen brugere matchede din søgning.</div>
      }
    </mat-card-content>
  </mat-card>

  <mat-card class="table-card">
    <mat-card-header>
      <mat-card-title>Brugere med forplejningslink</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <table mat-table [dataSource]="linkedTableDataSource" class="links-table">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Navn</th>
          <td mat-cell *matCellDef="let row">{{ row.name || 'Ukendt bruger' }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let row">{{ row.email || '–' }}</td>
        </ng-container>

        <ng-container matColumnDef="link">
          <th mat-header-cell *matHeaderCellDef>Unikt link</th>
          <td mat-cell *matCellDef="let row">
            @if (absoluteLink(row); as link) {
              <a [href]="link" target="_blank" rel="noopener">{{ link }}</a>
            } @else {
              <span>–</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button mat-stroked-button color="primary" (click)="copyLink(row)" [disabled]="!row.link_uuid || deletingUserId === row.user_id" matTooltip="Kopiér link">
              <mat-icon>content_copy</mat-icon>
              Kopiér
            </button>
            <button mat-stroked-button color="warn" class="delete-btn" (click)="deleteLink(row)" [disabled]="!row.link_uuid || deletingUserId === row.user_id" matTooltip="Slet link permanent">
              <mat-icon>delete</mat-icon>
              {{ deletingUserId === row.user_id ? 'Sletter…' : 'Slet' }}
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">Ingen forplejningslinks oprettet endnu.</td>
        </tr>
      </table>

      @if (copiedLink) {
        <div class="copied-message">Link kopieret: {{ copiedLink }}</div>
      }
    </mat-card-content>
  </mat-card>
</div>
